<template>
  <el-main class="el-main-wrapper">

    <keep-alive :include="include">
      <!-- 需要缓存的视图组件 -->
      <router-view v-if="$route.meta.keepAlive">
      </router-view>
    </keep-alive>

    <!-- 不需要缓存的视图组件 -->
    <router-view v-if="!$route.meta.keepAlive">
    </router-view>

    <!-- <router-view></router-view> -->
  </el-main>
</template>
<script>
export default {
  name: 'LayoutMain',
  data() {
    return {
      include: []
    }
  },
  watch: {
    $route(to, from) {
      console.log(to, from)
      // 如果 要 to(进入) 的页面是需要 keepAlive 缓存的，把 name push 进 include数组
      if (to.meta.keepAlive) {
        !this.include.includes(to.name) && this.include.push(to.name)
      }
      // if (to.meta.keepAlive && from.meta.keepAlive) {
      //   const index = this.include.indexOf(from.name)
      //   index !== -1 && this.include.splice(index, 1)
      // }
      // 如果 要 form(离开) 的页面是 keepAlive缓存的，
      // 再根据 deepth 来判断是前进还是后退
      // 如果是后退
      if (from.meta.keepAlive && to.meta.deepth < from.meta.deepth) {
        const index = this.include.indexOf(from.name)
        index !== -1 && this.include.splice(index, 1)
      }
    }
  },
  mounted() {
    console.log(this.$route)
    const { name, meta } = this.$route
    if (meta.keepAlive) {
      !this.include.includes(name) && this.include.push(name)
    }
  }
}
</script>
<style lang="stylus">
.el-main-wrapper {
  background: #eee;
  overflow: auto;
  padding: 8px;
}
</style>
